(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  const bindNavigation = () => {
    document.querySelectorAll('.at-navigation details').forEach(item => {
      item.addEventListener('toggle', () => {
        if (item.open) document.querySelectorAll('.at-navigation details[open]').forEach(other => { if (other !== item) other.open = false; });
      });
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.at-header details[open],.at-filters[open]').forEach(item => { item.open = false; item.querySelector('summary')?.focus(); });
    });
    document.addEventListener('click', event => {
      document.querySelectorAll('.at-navigation details[open]').forEach(item => { if (!item.contains(event.target)) item.open = false; });
    });
    document.querySelectorAll('[data-sort]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  };
  const bindFeed = root => {
    if (root.dataset.feedBound) return;
    root.dataset.feedBound = 'true';
    const grid = root.querySelector('[data-feed-grid]');
    let pager = root.querySelector('[data-feed-pagination]');
    if (!grid || !pager) return;
    if (root.dataset.deduplicate) {
      const seen = new Set();
      document.querySelectorAll('.at-card[data-product-id]').forEach(card => {
        if (grid.contains(card) && seen.has(card.dataset.productId)) card.remove();
        else seen.add(card.dataset.productId);
      });
    }
    let loading = false;
    let paused = Boolean(window.Shopify?.designMode);
    let observer;
    let next = pager.querySelector('[data-feed-next]');
    const key = 'rassme-feed:' + location.pathname + location.search;
    let visited = new Set();
    try {
      if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
        const cache = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (cache && Date.now() - cache.time < 1800000 && cache.grid && cache.pager) {
          grid.innerHTML = cache.grid;
          pager.innerHTML = cache.pager;
          next = pager.querySelector('[data-feed-next]');
          visited = new Set(cache.visited || []);
          paused = true;
          requestAnimationFrame(() => { if (cache.scroll) window.scrollTo(0, cache.scroll); });
        }
      }
    } catch (error) {}
    const status = () => pager.querySelector('[data-feed-status]');
    const remember = () => {
      try {
        const html = grid.innerHTML;
        if (html.length < 1800000) sessionStorage.setItem(key, JSON.stringify({grid: html, pager: pager.innerHTML, time: Date.now(), visited: [...visited], scroll: scrollY}));
      } catch (error) {}
    };
    const pause = value => {
      paused = value;
      const button = pager.querySelector('[data-feed-pause]');
      if (button) { button.textContent = value ? root.dataset.resume : root.dataset.pause; button.setAttribute('aria-pressed', String(value)); }
    };
    const bindPager = () => {
      next = pager.querySelector('[data-feed-next]');
      const button = pager.querySelector('[data-feed-pause]');
      if (button) { button.hidden = false; button.textContent = paused ? root.dataset.resume : root.dataset.pause; button.addEventListener('click', () => { pause(!paused); if (!paused) observe(); }); }
      if (next) next.addEventListener('click', event => { if (!event.ctrlKey && !event.metaKey && !event.shiftKey) { event.preventDefault(); load(true); } });
      observe();
    };
    const observe = () => {
      observer?.disconnect();
      if (!next || !('IntersectionObserver' in window)) return;
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && !paused && !loading && !document.hidden) load(false);
      }, {rootMargin: '160px 0px'});
      observer.observe(next);
    };
    const load = async manual => {
      if (loading || !next) return;
      const target = new URL(next.href, location.origin);
      if (target.origin !== location.origin || visited.has(target.href)) return;
      loading = true;
      observer?.disconnect();
      next.setAttribute('aria-disabled', 'true');
      root.setAttribute('aria-busy', 'true');
      if (status()) status().textContent = root.dataset.loading;
      const url = new URL(target.href);
      url.searchParams.set('section_id', root.dataset.fetchSection);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 18000);
      try {
        const response = await fetch(url.href, {signal: controller.signal, credentials: 'same-origin', headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (!response.ok) throw new Error('Load failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.querySelector('[data-feed-grid]');
        const incomingPager = doc.querySelector('[data-feed-pagination]');
        if (!incoming || !incomingPager) throw new Error('Incomplete response');
        const existing = new Set([...(root.dataset.deduplicate ? document : grid).querySelectorAll('.at-card[data-product-id]')].map(card => card.dataset.productId));
        const cards = [...incoming.children].filter(card => !existing.has(card.dataset.productId));
        const fragment = document.createDocumentFragment();
        cards.forEach(card => fragment.appendChild(card));
        grid.appendChild(fragment);
        visited.add(target.href);
        pager.innerHTML = incomingPager.innerHTML;
        next = pager.querySelector('[data-feed-next]');
        if (manual && cards[0]) cards[0].querySelector('a')?.focus({preventScroll: true});
        if (status()) status().textContent = next ? `${grid.querySelectorAll('[data-product-id]').length} / ${root.dataset.total}` : root.dataset.complete;
        bindPager();
        remember();
      } catch (error) {
        pause(true);
        if (status()) status().textContent = root.dataset.error;
        next?.removeAttribute('aria-disabled');
      } finally {
        clearTimeout(timeout);
        loading = false;
        root.removeAttribute('aria-busy');
        next?.removeAttribute('aria-disabled');
      }
    };
    bindPager();
    window.addEventListener('pagehide', remember);
    root.addEventListener('click', event => { if (event.target.closest('.at-card a')) remember(); });
    document.querySelectorAll('a[href="#customer-care"]').forEach(link => link.addEventListener('click', () => pause(true)));
  };
  const init = () => { bindNavigation(); document.querySelectorAll('[data-feed]').forEach(bindFeed); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-feed]').forEach(bindFeed); });
})();
